import { generateNomenApi, generateNomenOptions } from '@feature/nomenclature';

const translationTypeApi = generateNomenApi(`/nomen/translation-type`);

export const translationTypeOptions = generateNomenOptions('translation-type', translationTypeApi);
